var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonalisedExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.132324 16.4685C0.132324 12.7886 2.57749 9.66177 5.75503 9.66177C5.97432 9.66177 6.15209 9.83954 6.15209 10.0588C6.15209 10.2781 5.97432 10.4559 5.75503 10.4559C3.15997 10.4559 0.926442 13.0679 0.926442 16.4685V16.5903C0.926442 16.9364 1.14168 17.0735 1.24704 17.0735H8.47056C8.68985 17.0735 8.86762 17.2513 8.86762 17.4706C8.86762 17.6899 8.68985 17.8676 8.47056 17.8676H1.24704C0.558098 17.8676 0.132324 17.2143 0.132324 16.5903V16.4685Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20603 0.926472C6.23242 0.926472 4.6325 2.5264 4.6325 4.5C4.6325 6.47361 6.23242 8.07353 8.20603 8.07353C10.1796 8.07353 11.7796 6.47361 11.7796 4.5C11.7796 2.5264 10.1796 0.926472 8.20603 0.926472ZM3.83838 4.5C3.83838 2.08782 5.79384 0.132355 8.20603 0.132355C10.6182 0.132355 12.5737 2.08782 12.5737 4.5C12.5737 6.91219 10.6182 8.86765 8.20603 8.86765C5.79384 8.86765 3.83838 6.91219 3.83838 4.5Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2352 7.54412C13.3785 7.54412 13.5107 7.62136 13.5811 7.74621L15.0042 10.2711L17.8452 10.8443C17.9857 10.8726 18.1001 10.9745 18.1443 11.1108C18.1886 11.2471 18.156 11.3967 18.059 11.5022L16.0975 13.6359L16.4303 16.515C16.4467 16.6574 16.3852 16.7976 16.2692 16.8818C16.1533 16.9661 16.0009 16.9813 15.8706 16.9216L13.2352 15.7155L10.5998 16.9216C10.4695 16.9813 10.3172 16.9661 10.2012 16.8818C10.0853 16.7976 10.0237 16.6574 10.0402 16.515L10.3729 13.6359L8.4114 11.5022C8.3144 11.3967 8.28179 11.2471 8.32608 11.1108C8.37037 10.9745 8.48468 10.8726 8.62518 10.8443L11.4662 10.2711L12.8893 7.74621C12.9597 7.62136 13.0919 7.54412 13.2352 7.54412ZM13.2352 8.74982L12.0688 10.8193C12.0121 10.9198 11.9145 10.9907 11.8014 11.0135L9.47278 11.4834L11.0805 13.2322C11.1586 13.3172 11.1959 13.4319 11.1826 13.5465L10.9099 15.9064L13.07 14.9178C13.1749 14.8698 13.2955 14.8698 13.4005 14.9178L15.5605 15.9064L15.2878 13.5465C15.2745 13.4319 15.3118 13.3172 15.3899 13.2322L16.9976 11.4834L14.669 11.0135C14.5559 10.9907 14.4583 10.9198 14.4017 10.8193L13.2352 8.74982Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalisedExperience);
export default __webpack_public_path__ + "static/media/PersonalisedExperience.6f785580e2790b0a0986ddaedb0cb411.svg";
export { ForwardRef as ReactComponent };